import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { COLORS } from "./PlotGraph"
import { ProcessingResponseTimes } from "../services/adminService"
import { tutToDate } from "../util"



const ProcessingAndResponseTimesChart = ({ graphData }: { graphData: ProcessingResponseTimes | undefined}) => {
    if (graphData === undefined || graphData.timestamps.length === 0) {
        return <div>No data available</div>;
    }
    let graphableData = graphData.timestamps.map((timestamp, index) => {
        return {
            date: tutToDate(timestamp),
            processingSpeed: graphData.processingTimes[index],
            responseSpeed: graphData.responseTimes[index]
        }
    });
    return (
        <ResponsiveContainer width="100%" height={400} style={{ paddingBottom: "5rem" }}>
            <LineChart
                data={graphableData}
                margin={{
                    top: 0,
                    right: 10,
                    left: 10,
                    bottom: 0
                }}>
                <CartesianGrid strokeDasharray="5 5 " opacity={0.2} />
                <XAxis
                    dataKey="date"
                    type="category"
                    interval="preserveStartEnd" // Ensures fewer, evenly spaced ticks
                    minTickGap={80} // Increase spacing between ticks
                    tickFormatter={(date: Date) =>
                        date.toLocaleString(undefined, {
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                        })
                    }
                    label={{ value: "Time", position: "insideBottomLeft", offset: -5 }}
                />
                <YAxis
                    label={{ value: "Response Speed (ms)", angle: 90, position: "insideLeft" }}
                    yAxisId={"left"}
                />
                <YAxis
                    label={{ value: "Processing Speed (ms)", angle: -90, position: "insideRight" }}
                    yAxisId={"right"}
                    orientation="right"
                />
                <Legend />
                <Tooltip
                    labelFormatter={(label: Date) =>
                        label.toLocaleString(undefined, {
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                        })
                    }
                />
                <Line
                    type="monotone"
                    dataKey="responseSpeed"
                    yAxisId="left"
                        name="Response Time"
                    stroke={`${COLORS[0]}`}
                    activeDot={{ r: 8 }}
                    strokeWidth={4}
                    dot={false}
                />
                <Line
                    type="monotone"
                    dataKey="processingSpeed"
                    yAxisId="right"
                    name="Processing Speed"
                    stroke={`${COLORS[1]}`}
                    activeDot={{ r: 8 }}
                    strokeWidth={4}
                    dot={false}
                />
            </LineChart>
        </ResponsiveContainer>
    )
}

export default ProcessingAndResponseTimesChart;